import { WORK_DIR } from '~/utils/constants';

export function addWorkDir(filePath: string) {
  if (filePath.length > 0 && !filePath.startsWith('/')) {
    filePath = `${WORK_DIR}/${filePath}`;
  }

  return filePath;
}

export function removeWorkDir(filePath: string) {
  if (filePath.startsWith(`${WORK_DIR}/`)) {
    filePath = filePath.slice(WORK_DIR.length + 1);
  }

  return filePath;
}
